<template>
	<SOSlotBase>
		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Pembenahan Transaksi'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-20">
				<div class="rounded p-x-8 p-y-8 m-d-20" style="background-color: #EDF5FF">
					<div class="f-regular f-16 f-c-black m-d-16">
						Jika ada pertanyaan mengenai pembenahan transaksi, silahkan hubungi customer service kami
					</div>
					<SOButton
						class="bg-white"
						:outline="true"
						:full="true"
						:text="'Hubungi CS Smartlink'"
						@action="callCS"
					/>
				</div>

				<div
					class="p-x-12 p-y-12 m-d-20"
					style="border: 2px solid #eeeeee; border-radius: 8px"
					v-for="(input, i) in inputs"
					:key="i"
				>
					<div class="m-d-8" @click="$router.push('/transaksi/reguler/detail/' + input.idtransaksi)">
						<div class="f-semi f-16 f-c-black m-d-4 d-flex-between-center">
							<div>
								{{ input.idtransaksi }}
							</div>
							<div>
								<i class="fas fa-chevron-right f-c-midgrey"></i>
							</div>
						</div>
						<div class="f-regular f-14 f-c-black">
							{{ input.nama_customer }} - {{ input.no_telp }}
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							Diterima: {{ input.diterima }}
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							Selesai: {{ input.selesai_formated }}
						</div>
					</div>

					<div class="separator-line"></div>

					<div class="m-t-8" v-if="input.is_submited === 0">
						<div class="f-regular f-14 f-c-black">
							Pembayaran transaksi
						</div>
						<SOInputSelect
							class="m-d-4"
							:required="true"
							:title="'Tipe bayar'"
							:options="tipeBayarOption"
							:selected="inputs[i].jawaban_tipe_bayar"
							:placeholder="'bayar dengan cara apa ?'"
							@option-selected="(v) => { inputs[i].jawaban_tipe_bayar = v }"
						/>
						<SOInputSelect
								class="m-d-4"
								:required="true"
								:title="'Metode bayar '"
								:options="metodeBayarOption"
								:selected="inputs[i].jawaban_metode_bayar"
								:placeholder="'Bayar via metode apa?'"
								@option-selected="(v) => { inputs[i].jawaban_metode_bayar = v }"
						/>
						<SOInputRegular
								v-if="inputs[i].jawaban_metode_bayar==2"
								:title="'Masuk ke Akun Bank mana ? '"
								:placeholder="'Contoh : Bank Mandiri '"
								:validation="'alphanumeric'"
								:required="false"
								v-model="input.jawaban_idakun_debit"
						/>
						<SOInputNominal
							class="m-d-4"
							:required="true"
							:title="'Nominal'"
							:use-comma="true"
							:prefix="'Rp'"
							:prefix-left="true"
							:defaultValue="input.nominal.formatted"
							@input="(v) => { input.nominal = v }"
						/>

						<SOButton
							:primary="true"
							:loading="pageSetting.btn.loading"
							:disable="pageSetting.btn.disabled"
							:full="true"
							:text="'Simpan'"
							@action="submitPembenahan(i)"
						/>
					</div>

					<div class="m-t-8 f-regular f-14 f-c-midgrey" v-else>
						Sedang dicek oleh developer
					</div>
				</div>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRegular from "../so-components/global/input/SOInputRegular";

export default {
	name: "BugTransaksi", // https://codepen.io/lindstrom/pen/vzRrEP
	data() {
		return {
			inputs: [],
			tipeBayarOption: [
				{
					id: 1,
					text: "Lunas Didepan"
				},
				{
					id: 2,
					text: "DP"
				},
			],
			metodeBayarOption: [
				{
					id: 1,
					text: "Tunai (Kas Laci)"
				},
				{
					id: 2,
					text: "Debit/Transfer"
				},
				{
					id: 3,
					text: "E-Payment"
				},
			],
			pageSetting: {
				btn: {
					loading: false,
					disabled: false,
				}
			},
			requestHeaders: {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('token'),
				}
			},
		}
	},
	components: {
		SOInputRegular,
		SOTitleBar,
		SOSlotBase,
		SOInputSelect,
		SOInputNominal,
		SOButton,
	},
	mounted() {
		// for (var i = 0; i < 5; i++) {
		// 	this.addData();
		// }
		this.getTransaksi();
	},
	methods: {
		back() {
			this.$router.push("/dashboard")
		},

		// addData() {
		// 	this.inputs.push({
		// 		idTiteBayar: "1",
		// 		nominal: {
		// 			formatted: "",
		// 			raw: 0,
		// 			submitted: false,
		// 		}
		// 	});
		// },
		async getTransaksi() {
			try {
				const response = await this.$axios.get(this.$baseurl + 'masterData/hot_fix/get_failed_payments_transaction', this.requestHeaders)
				if (response.status === 200) {
					if (response.data.status === true) {
						response.data.data.main_data.forEach((v) => {
							let nominal = {
								nominal: {
									formatted: v.jawaban_nominal_bayar.toString(),
									raw: v.jawaban_nominal_bayar
								}
							}
							this.inputs.push({...v, ...nominal})
						})
					}
				}
			} catch (e) {
				this.$toast.error(e)
			}
		},

		async submitPembenahan(i) {
			this.pageSetting.btn.loading = true
			this.pageSetting.btn.disabled = true
			try {
				let form = new FormData
				form.append("idtransaksi", this.inputs[i].idtransaksi)
				form.append("tipe_bayar", this.inputs[i].jawaban_tipe_bayar)
				form.append("metode_bayar", this.inputs[i].jawaban_metode_bayar)
				form.append("idakun_debit", this.inputs[i].jawaban_idakun_debit)
				form.append("nominal_bayar", this.inputs[i].nominal.raw)
				const response = await this.$axios.post(this.$baseurl + 'masterData/hot_fix/update_data_payments_transaction', form, this.requestHeaders)
				if (response.status === 200) {
					if (response.data.status === true) {
						this.$toast.success(response.data.msg + " untuk nomor nota " + this.inputs[i].idtransaksi)
						this.inputs[i].is_submited = 1
					}else{
						this.$toast.error(response.data.msg)
					}
				}
			} catch (e) {
				this.$toast.error(e)
			}
			this.pageSetting.btn.loading = false
			this.pageSetting.btn.disabled = false
		},

		callCS() {
			window.location.href = 'https://wa.me/6285234494494';
		}
	}
}
</script>